import * as React from "react";
import { ReactSVG } from "react-svg";
import { setSvgSize, processSvgInjection, SvgRefStore } from "../helpers/svg";

export default React.memo(
  function SVGInsert({
    svgPath,
    svgRefStore,
    lookupRefs,
    textAnchorRight = [],
    setSize = false,
    refPrefix = "",
  }: {
    svgPath: string;
    svgRefStore: SvgRefStore;
    lookupRefs: Record<string, string>;
    textAnchorRight?: string[];
    setSize?: boolean;
    refPrefix?: string;
  }): React.ReactElement {
    return (
      <ReactSVG
        src={svgPath}
        beforeInjection={(svg) => {
          if (setSize) {
            setSvgSize(svg);
          }
        }}
        afterInjection={(svg) => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          processSvgInjection(svg, svgRefStore, lookupRefs, textAnchorRight, refPrefix);
        }}
      />
    );
  },
  (prev, next) => prev.svgPath === next.svgPath,
);
